export const BREAK_POINT_LG = 1024;
